export default {
  props: {
    search: {
      type: String,
    },
  },
  watch: {
    search: {
      handler: function (newVal) {
        this.filter.search = newVal;
      },
      immediate: true,
    },
  },
};
